import { IModule } from '@/contracts/core/module/interface/IModule'
import { IWindow } from '@/system-modules/win-manager/v1/core/interface/IWindow'

class Window implements IWindow {
  public module: IModule | null = null

  getModule(): IModule {
    if (!this.module) {
      throw new Error('Module is not set for this window')
    }
    return this.module
  }
  setModule(module: IModule): void {
    this.module = module
  }
}

export default Window
